import { GET, DELETE } from './api'

// O que os personagens guardaram sobre a pessoa logada: a ficha (nome, idioma,
// assuntos) e as conversas guardadas no servidor, com o resumo de cada uma.
export const LerMinhaMemoria = async () => {
    return await GET(`/minha-memoria`, true);
}

// Apaga tudo o que o servidor guardou sobre a pessoa (ficha e conversas).
export const ApagarMinhaMemoria = async () => {
    return await DELETE(`/minha-memoria`, true);
}
